import { DateTime } from 'luxon';

export const getHour = (dateTime) => {
  return DateTime.fromISO(dateTime, { zone: 'utc'}).toFormat("HH:mm", { locale: 'ru'});
}

export const getDay = (epoch) => {
  if (!epoch) return '';
  let dateTime = epoch;
  if (typeof epoch !== 'object') {
    dateTime = DateTime.fromSeconds(dateTime);
  }

  return dateTime.setLocale('ru')?.toLocaleString( { month: 'short', day: 'numeric' } )
}

export const getDateString = (epoch) => {
  if (!epoch) return '';
  let dateTime = epoch;
  if (typeof epoch !== 'object') {
    dateTime = DateTime.fromSeconds(dateTime);
  }
  return dateTime.setLocale('ru').toLocaleString( { month: 'short', day: 'numeric', year: 'numeric' } );
}

export const getWeekday = (epoch) => {
  if (!epoch) return '';
  let dateTime = epoch;
  if (typeof epoch !== 'object') {
    dateTime = DateTime.fromSeconds(dateTime);
  }

  return DateTime.fromSeconds(epoch).setLocale('ru')?.weekdayLong;
}
export const getHourMinutes = (epoch) => {
  if (!epoch) return '';
  let dateTime = epoch;
  if (typeof epoch !== 'object') {
    dateTime = DateTime.fromSeconds(dateTime);
  }

  return DateTime.fromSeconds(epoch).setLocale('ru')?.toFormat('HH:mm');
}
